import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';
import { NewReportOptionsTemplateDirective } from '../../../shared/directives/new-report-options-template.directive';
import { ReportLocationEligibilityStatusOptionComponent } from '../../../shared/components/report-location-eligibility-status-option/report-location-eligibility-status-option.component';
import { ReportClientOptionComponent } from '../../../shared/components/report-client-option/report-client-option.component';
import { ReportTextOptionComponent } from '../../../shared/components/report-text-option/report-text-option.component';
import { ReportClientEntityTypeOptionComponent } from '../../../shared/components/report-client-entity-type-option/report-client-entity-type-option.component';
import { ReportClientLeadOptionComponent } from '../../../shared/components/report-client-lead-option/report-client-lead-option.component';
import { ReportDetailsTemplateDirective } from '../../../shared/directives/report-details-template.directive';
import { ReportAppliedLocationEligibilityStatusOptionComponent } from '../../../shared/components/report-applied-location-eligibility-status-option/report-applied-location-eligibility-status-option.component';
import { ReportAppliedClientOptionComponent } from '../../../shared/components/report-applied-client-option/report-applied-client-option.component';
import { ReportAppliedTextOptionComponent } from '../../../shared/components/report-applied-text-option/report-applied-text-option.component';
import { ReportAppliedClientEntityTypeOptionComponent } from '../../../shared/components/report-applied-client-entity-type-option/report-applied-client-entity-type-option.component';
import { ReportAppliedClientLeadOptionComponent } from '../../../shared/components/report-applied-client-lead-option/report-applied-client-lead-option.component';

@Component({
    templateUrl: './capture-admin-patient-interaction-location-reports.component.html',
    styleUrls: ['./capture-admin-patient-interaction-location-reports.component.scss'],
    imports: [ReportsComponent,
              NewReportOptionsTemplateDirective,
              FormsModule,
              ReactiveFormsModule,
              ReportLocationEligibilityStatusOptionComponent,
              ReportClientOptionComponent,
              ReportTextOptionComponent,
              ReportClientEntityTypeOptionComponent,
              ReportClientLeadOptionComponent,
              ReportDetailsTemplateDirective,
              ReportAppliedLocationEligibilityStatusOptionComponent,
              ReportAppliedClientOptionComponent,
              ReportAppliedTextOptionComponent,
              ReportAppliedClientEntityTypeOptionComponent,
              ReportAppliedClientLeadOptionComponent]
})
export class CaptureAdminPatientInteractionLocationReportsComponent {
  private formBuilder = inject(UntypedFormBuilder);

  reportsUrl = `${environment.captureApi.url}/patient_interaction_location_reports`;

  filtersForm = this.formBuilder.group({
    clientIds: [null],
    assignedClientLeadsIds: [null],
    clientEntityTypes: [null],
    eligibilityStatuses: [null],
    name: [null],
  });
}
